export const PROPOSAL_STATUS = {
  CREATED: 0,
  APPROVED_BY_COMPANY: 1, // projecto inseriu seus valores e salvou a proposta
  APPROVED_BY_CUSTOMER: 2, // projeto enviado e aprovado pelo cliente, pode gerar o processo
  REFUSED: 3,
  PROCESSED: 4, // usando quando a ordem de serviço é criada
  FINISHED: 4 // usado quando o processo termina e não há mais nada para fazer no projeto
}

export const COLLABORATOR_STATUS = {
  ACTIVE: 0,
  INACTIVE: 1
}

export const PROVIDERS_STATUS = {
  ACTIVE: 0,
  INACTIVE: 1
}

export const PAYMENTS_REFUND_REQUESTED = {
  NO: 0,
  YES: 1
}

export const NOTIFICATIONS_TYPE = {
  'pre-proposal-approvement-boss-sector': 'pre-proposal-approvement-boss-sector',
  'provider-create-boss-sector': 'provider-create-boss-sector',
  'pre-proposal-updated-boss-sector': 'pre-proposal-updated-boss-sector',
  info: 'info'
}

export const NOTIFICATIONS_STATUS = {
  not_viewed: 0,
  viewed: 1
}

export const DEPARTMENTS_OPTIONS = {
  levantamento: 0,
  viabilidade: 1,
  aprovacao: 2,
  financeiro: 3,
  rh: 4,
  adm: 5
}
